import { render } from "./dashboard-activity.vue?vue&type=template&id=60b31b23"
import script from "./dashboard-activity.vue?vue&type=script&lang=js"
export * from "./dashboard-activity.vue?vue&type=script&lang=js"

import "./dashboard-activity.vue?vue&type=style&index=0&id=60b31b23&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__